import React from "react";

const UserManagementFormContext = React.createContext({});

export default UserManagementFormContext;
